import {
  CategoryConfigFactory,
  massConfig,
  NumericDiff,
} from "components/search/input/DifferencePanel/common";
import { NameBasedInventoryItem } from "store/api/generatedApi";

export const InventoryItemConfigFactory: CategoryConfigFactory<
  NameBasedInventoryItem
> = (utils) => {
  const { t, units, formatNumber2DPFixed, isAdmin } = utils;
  return {
    quantity: {
      title: t("inventoryInHand"),
      ...massConfig(utils),
    },
    specific_price: {
      title: t("pricePerTonne"),
      renderDiff: ({ updatedVal, previousVal }) => {
        return (
          <NumericDiff
            previous={previousVal ?? 0}
            updated={updatedVal ?? 0}
            prefix={units("cost")}
            format={formatNumber2DPFixed}
            suffix={`/${units("mass", false)}`}
          />
        );
      },
      format: (val) => `${units("cost")}${formatNumber2DPFixed(val)}`,
    },
    ...(isAdmin
      ? {
          previous_quantity: {
            title: t("lastInventoryReport"),
            ...massConfig(utils),
          },
          deliveries_since_previous: {
            title: t("recordedDeliveries"),
            ...massConfig(utils),
          },
          consumption_since_previous: {
            title: t("recordedConsumption"),
            ...massConfig(utils),
          },
          projected_deliveries_since_previous: {
            title: t("assumedDeliveries"),
            ...massConfig(utils),
          },
          projected_consumption_since_previous: {
            title: t("projectedConsumptionToPlan"),
            ...massConfig(utils),
          },
        }
      : {}),
  };
};
